import { on } from "delegated-events";
import type { HtmxRequestConfig } from "htmx.org";

type HtmxConfirm = HtmxRequestConfig & {
  issueRequest: () => void,
};

on('submit', 'form[data-async-csrf]', async (event) => {
  event.preventDefault();

  const { currentTarget: $form, submitter: $submitter } = event;

  if (Object.keys($form.dataset).includes('hxPost')) {
    return;
  }

  if ($submitter instanceof HTMLButtonElement) {
    $submitter.disabled = true;
    $submitter.dataset.loading = '1';
  }

  const response = await fetch('/actions/users/session-info', { headers: { 'Accept': 'application/json' }});
  const data = await response.json();

  const $csrfInput = document.createElement('input');
  $csrfInput.type = 'hidden';
  $csrfInput.name = data.csrfTokenName;
  $csrfInput.value = data.csrfTokenValue;

  $form.prepend($csrfInput);
  $form.submit();
});

let csrfToken: string;

on('htmx:confirm', 'form[data-async-csrf]', async (event: CustomEvent<HtmxConfirm>) => {
  if (!csrfToken) {
    event.preventDefault();

    const response = await fetch('/actions/users/session-info', { headers: { 'Accept': 'application/json' }});
    const data = await response.json();

    csrfToken = data.csrfTokenValue;

    event.detail.issueRequest();
  }
});

on('htmx:configRequest', 'form[data-async-csrf]', (event: CustomEvent<HtmxRequestConfig>) => {
  // eslint-disable-next-line no-param-reassign
  event.detail.headers['X-CSRF-Token'] = csrfToken;
});
